<template>

    <div>

        <b-modal id="modal-editar-detalle-falta" ref="my-modal-editar-detalle-falta" :ok-title="btnEditarDetalleFalta"
            cancel-title="Cerrar" centered size="lg" :title="titleModalEditarDetalleFalta"
            @show="resetModalEditarDetalleFalta" @hidden="resetModalEditarDetalleFalta"
            @ok="handleOkEditarDetalleFalta">

            <validation-observer ref="simpleRules">
                <b-form>

                    <b-form-group>
                        <label>Cultivo</label>
                        <validation-provider #default="{ errors }" rules="required" name="Cultivo">
                            <b-form-select v-model="selectedCultivoGuardar"
                                :state="errors.length > 0 ? false : null"
                                :options="optionsCultivoGuardar" />
                            <small class="text-danger" v-if="errors[0]">El campo Cultivo es
                                obligatorio</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group>
                        <label>Fecha</label>
                        <validation-provider #default="{ errors }" rules="required" name="Fecha">
                            <b-input-group class="mb-1">
                                <b-form-input id="fechaGuardar" v-model="fechaGuardar" type="text" placeholder="YYYY-MM-DD" autocomplete="off" show-decade-nav :state="errors.length > 0 ? false : null"/>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="fechaGuardar" show-decade-nav button-only right
                                        locale="es-ES" aria-controls="fechaGuardar" size="sm" />
                                </b-input-group-append>
                            </b-input-group>

                            <small class="text-danger" v-if="errors[0]">El campo Fecha es
                                obligatorio</small>
                        </validation-provider>
                    </b-form-group>

                </b-form>
            </validation-observer>
        </b-modal>

        <div class="row">
            <div class="col-md-6 co-12">
                <b-card title="Fechas de Configuracion para Cant. de Sanciones">

                    <b-row>
                        <b-col md="6" sm="8" class="my-1">
                            <b-form-group>
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    v-on:click="mostrarModalCategoriaNuevo()" size="sm" variant="primary">
                                    Nuevo
                                </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col md="6" class="my-1">
                            <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                                label-for="filterInput" class="mb-0">
                                <b-input-group size="sm">
                                    <b-form-input id="filterInput" v-model="filter" type="search"
                                        placeholder="Escribe para buscar" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>


                        <b-col cols="12">

                            <b-table ref="selectableTable" small="small" responsive :per-page="perPage"
                                :current-page="currentPage" :items="categorias" :fields="fieldsCategorias"
                                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                                :filter="filter" :filter-included-fields="filterOn" @filtered="onFilteredCategorias"
                                :busy="cargandoCategoria" show-empty>

                                <template #empty="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros para mostrar</div>
                                    </div>
                                </template>
                                <template #emptyfiltered="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros que coincidan con su solicitud
                                        </div>
                                    </div>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-dark my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Cargando...</strong>
                                    </div>
                                </template>

                                <template #cell(id)="data">
                                    <b-input-group-append>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-success"
                                            class="btn-icon" v-on:click="editarCategoria(data.value)">
                                            <feather-icon icon="Edit2Icon" />
                                        </b-button>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                                            class="btn-icon" v-on:click="eliminarCategoria(data.value)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </b-input-group-append>
                                </template>

                            </b-table>
                        </b-col>

                        <b-col md="7" sm="8" class="my-1">
                            <b-form-group class="mb-0">
                                <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                                    class="w-50" />
                            </b-form-group>
                        </b-col>

                        <b-col md="5" class="my-1">
                            <b-pagination v-model="currentPage" :total-rows="totalRowsCategorias" :per-page="perPage"
                                align="center" size="sm" class="my-0" />
                        </b-col>
                    </b-row>

                </b-card>
            </div>
        </div>


    </div>

</template>
<script>
import axios from 'axios'
import axiosIns from '../../../libs/axios'
import {
    BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BModal, VBModal,
    BForm, BCardText, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Swal from 'sweetalert2'
import moment from 'moment'

import {
    required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'

export default {
    components: {
        ValidationProvider, ValidationObserver,
        BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow,
        BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
        BInputGroupAppend, BButton, BModal, VBModal, BForm, BCardText, vSelect, Swal,
        BSpinner, BFormDatepicker
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {

            cargandoCategoria: true,
            categorias: [],
            categoria: [],
            idCategoria: null,

            fechaGuardar: '',

            perPage: 5,
            pageOptions: [3, 5, 10],
            totalRowsCategorias: 1,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            zonas: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fieldsCategorias: [
                { key: 'id', label: 'Opciones', },
                { key: 'empresa', label: 'Empresa', sortable: true },
                { key: 'cultivo', label: 'Cultivo', sortable: true },
                { key: 'nombre_usuario', label: 'Usuario', sortable: true },
                { key: 'fecha', label: 'Fecha', sortable: true },
            ],

            key_empresa_sap: '',
            key_empresa_sap_descripcion: '',

            selectedCultivoGuardar: null,
            optionsCultivoGuardar: [],
            optionCultivosNoCampo: [],
            trabajadores: [],

            btnEditarDetalleFalta: '',
            titleModalEditarDetalleFalta: '',



        }
    },
    methods: {

        resetModalEditarDetalleFalta() {
            /*this.descripcionEditarDetalleFalta = ''
            this.observacioninvolucrado = ''
            this.selectedFirmoPapeleta = null*/
        },

        editarCategoria(id) {
            this.categoria = [];
            this.idCategoria = id;
            this.titleModalEditarDetalleFalta = "Editar Fecha Configuracion";
            this.btnEditarDetalleFalta = "Editar";

            const config = {
                method: 'get',
                url: '/sap/md/fechaconfiguracion/detalle/' + id,
            };

            axiosIns(config)
                .then((response) => {
                    //console.log(JSON.stringify(response.data));
                    if (response.status === 200) {
                        this.categoria = response.data;

                        this.selectedCultivoGuardar = this.categoria.cultivo;
                        this.fechaGuardar = this.categoria.fecha;

                        this.$refs['my-modal-editar-detalle-falta'].show();
                    }
                })
                .catch((error) => {
                    //console.log(error);
                })
                .finally(() => {
                    //this.cargandoCategoria = false;
                });


        },

        handleOkEditarDetalleFalta(bvModalEvt) {
            bvModalEvt.preventDefault()

            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.guardarEditar()
                }
            })
        },

        guardarEditar(){
            const valor = JSON.parse(localStorage.getItem('userData'));

          const fechaActual = moment()
              .format('YYYY-MM-DD')

          if (this.idCategoria !== null) {

                const data = {
                    "empresa": this.key_empresa_sap_descripcion,
                    "cultivo": this.selectedCultivoGuardar,
                    "fecha": this.fechaGuardar,
                    "dni_usuario": valor.dni,
                    "nombre_usuario": valor.fullName,
                    "fecha_actualizacion": fechaActual,
                };

                var config = {
                    method: 'put',
                    url: '/sap/md/fechaconfiguracion/editar/' + this.idCategoria,
                    data: data
                };

                axiosIns(config)
                    .then((response) => {
                        if (response.status === 200) {
                            this.obtenerFechas();

                            this.$nextTick(() => {
                                this.$refs['my-modal-editar-detalle-falta'].toggle('#toggle-btn')
                            })

                            this.successEditado("Fechas de Configuracion");
                        }
                        //true;
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorEditado("Fechas de Configuracion");
                        //false;
                        //        console.log(error);
                    })
                    .finally(() => {
                        //this.cargandoCategoria = false;
                    });

            } else {
                const data = {
                    "empresa": this.key_empresa_sap_descripcion,
                    "cultivo": this.selectedCultivoGuardar,
                    "fecha": this.fechaGuardar,
                    "dni_usuario": valor.dni,
                    "nombre_usuario": valor.fullName,
                    "fecha_creacion": fechaActual,
                    "fecha_actualizacion": fechaActual,
                    "estado": "1"
                };

                const config = {
                    method: 'post',
                    url: '/sap/md/fechaconfiguracion/crear/',
                    data: data
                };

                axiosIns(config)
                    .then((response) => {
                        if (response.status === 201) {
                            this.successRegistro("Fechas de Configuracion");

                            this.obtenerFechas();

                            this.$nextTick(() => {
                                this.$refs['my-modal-editar-detalle-falta'].toggle('#toggle-btn')
                            })
                        }
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorRegistro("Fechas de Configuracion");
                    });
            }
        },

        successRegistro(texto) {
            Swal.fire({
                title: 'Registro exitoso!',
                text: texto + ' se registro de manera satisfactoria!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        },
        errorRegistro(texto) {
            Swal.fire({
                title: 'Error!',
                text: texto + ' no se registro!',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        successEditado(texto) {
            Swal.fire({
                title: 'Modificación exitoso!',
                text: texto + ' se modificó de manera satisfactoria!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        },
        errorEditado(texto) {
            Swal.fire({
                title: 'Error!',
                text: texto + ' no se modificó!',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        onFilteredCategorias(filteredItems) {
            this.totalRowsCategorias = filteredItems.length
            this.currentPage = 1
        },
        obtenerFechas() {
            this.cargandoCategoria = true;
            this.categorias = [];

            const config = {
                method: 'get',
                url: '/sap/md/fechaconfiguracion/list/'
            };

            axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {

                        let categoriasTemporal = response.data;

                        categoriasTemporal.filter((item) => {
                            if (item.empresa === this.key_empresa_sap_descripcion) {
                                this.categorias.push(item);
                            }
                        });
                        this.totalRowsCategorias = this.categorias.length;
                        //console.log(this.categorias);
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error=======");
                    //this.obtenerFechas();
                })
                .finally(() => {
                    this.cargandoCategoria = false;
                });

        },
        obtenerEmpresa() {
            const valor = JSON.parse(localStorage.getItem('userData'));

          const config = {
            method: 'get',
            url: '/sap/md/getPersonal/?dni=' + valor.dni,
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            const order = 1;
                            const trabajador = response.data.response;

                            if (trabajador.length !== 0) {
                                trabajador.sort((a, b) => {
                                    a = new Date(a.fecha_ingreso);
                                    b = new Date(b.fecha_ingreso);
                                  const results = a > b ? -1 : a < b ? 1 : 0
                                  return results * order;
                                });
                                this.key_empresa_sap = trabajador[0].key_empresa_sap;

                                if (this.key_empresa_sap === "PE10") { //AGROVISION
                                    this.key_empresa_sap_descripcion = 'AGROVISIÓN PERÚ S.A.C'
                                }

                                if (this.key_empresa_sap === "PE20") { //ARENA VERDE
                                    this.key_empresa_sap_descripcion = 'ARENA VERDE'
                                }

                                this.obtenerTrabajadores();
                                this.obtenerFechas();

                            }

                        }

                    }

                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error=======");
                    //this.obtenerEmpresa();
                });
        },
        obtenerZonas() {
            this.zonas = [];

          const config = {
            method: 'get',
            url: '/pagricolas/data_lineal/',
            headers: {}
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        this.zonas = response.data;
                        this.listarCultivo();
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error=======");
                    //this.obtenerZonas();
                });
        },
        listarCultivo() {
            this.selectedCultivoGuardar = null;
            this.optionsCultivoGuardar = [];

            const optionsCultivoGuardarTemp = [];

            this.zonas.filter((item) => {
                if (item.sociedad === this.key_empresa_sap_descripcion) {
                    if (optionsCultivoGuardarTemp.indexOf(item.cultivo) < 0) {
                        optionsCultivoGuardarTemp.push(item.cultivo);
                        this.optionsCultivoGuardar.push({ value: item.cultivo, text: item.cultivo });
                    }
                }
            });

            if(this.key_empresa_sap === 'PE20'){
                this.optionsCultivoGuardar = this.optionCultivosNoCampo;
            }

        },
        obtenerTrabajadores() {
            this.trabajadores = [];
            this.optionCultivosNoCampo = [];

          const config = {
            method: 'get',
            url: '/sap/md/getPersonal/',
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.status === true) {

                            const order = 1;
                            const trabajadoresUnicos = [];

                            this.trabajadores = response.data.response;

                            this.trabajadores.filter((item) => {
                                if (item.nombre_cargo !== 'OBRERO AGRARIO' && item.seccion !== '' && item.key_empresa_sap === this.key_empresa_sap) {
                                    if (this.optionCultivosNoCampo.findIndex(element => element.value === item.seccion) === -1) {
                                        this.optionCultivosNoCampo.push({ value: item.seccion, text: item.seccion });
                                    }
                                }
                            });

                            this.optionCultivosNoCampo.sort((a, b) => {
                                const valueA = a.value; // ignore upper and lowercase
                                const valueB = b.value; // ignore upper and lowercase
                                if (valueA < valueB) {
                                    return -1;
                                }
                                if (valueA > valueB) {
                                    return 1;
                                }
                                return 0;
                            });

                            this.obtenerZonas();

                        }

                    }

                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======trabajadores=======");
                    console.log("=======error=======");
                    //this.obtenerTrabajadores();
                });
        },

        mostrarModalCategoriaNuevo() {
            this.categoria = [];
            this.idCategoria = null;
            this.titleModalEditarDetalleFalta = "Crear Fecha Configuracion";
            this.btnEditarDetalleFalta = "Guardar";

            this.selectedCultivoGuardar = null;
            this.fechaGuardar = "";

            this.$refs['my-modal-editar-detalle-falta'].show();
        },

        eliminarCategoria(id) {
            this.idCategoria = id;

            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger'
                },
                buttonsStyling: false
            });

            swalWithBootstrapButtons.fire({
                title: 'Desea eliminar la Fecha de Configuracion?',
                text: "No se podrá recuperar después eliminada!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar!',
                cancelButtonText: 'No, cancelar!',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {

                    this.deleteCategoria();

                } else if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    swalWithBootstrapButtons.fire(
                        'Cancelado',
                        'Su Fecha de Configuracion no se elimino!',
                        'error'
                    )
                }
            });

        },
        deleteCategoria() {

          const data = {
            'estado': '0'
          }

          const config = {
            method: 'put',
            url: '/sap/md/fechaconfiguracion/editar/' + this.idCategoria,
            data: data
          }

          axiosIns(config)
                .then((response) => {

                    if (response.status === 200) {
                        Swal.fire(
                            'Eliminado!',
                            'Su Fecha de Configuracion fue elimnada con éxito!',
                            'success'
                        );
                        this.obtenerFechas();
                    }

                })
                .catch((error) => {
                    Swal.fire({
                        title: 'Error!',
                        text: ' No se elimino la Categoria!',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .finally(() => {
                    //this.cargandoCategoria = false;
                });

            },

    },
    created() {
        this.obtenerEmpresa();
    },
}
</script>
